import React, { useEffect, useState, useRef } from 'react'
import { Row, Separator, H4, Paragraph, IconButton } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { MenuClose } from '@fs/zion-icon'
import Cache from '@fs/zion-cache'

const containerStyles = css`
  background-color: white;
  height: 150px;
  position: fixed;
  z-index: 3;
  inset-inline-start: 65px;
  bottom: 32%;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.25);
  &:before,
  &:after {
    content: '';
    position: absolute;
    inset-inline-start: -30px; // Increase this to move the leader left
    top: 33%;
    width: 0;
    height: 0;
    border-top: 30px solid transparent; // Increase this to make the leader taller
    border-bottom: 30px solid transparent; // Increase this to make the leader taller
  }
  &:before {
    border-inline-end: 30px solid rgba(0, 0, 0, 0.1); // Increase this to make the leader longer
    filter: blur(10px);
    z-index: -1;
  }
  &:after {
    border-inline-end: 30px solid white; // Increase this to make the leader longer
  }
`
const FeedbackOverlay = ({ waitTime = 30000, handleOnClose = () => {} }) => {
  const [showPopup, setShowPopup] = useState(false)
  const showPopupId = useRef(null)
  const [t] = useTranslation()
  const cache = new Cache({ storeName: 'RIP_settings' })

  useEffect(() => {
    cache.getItem('closedFeedbackOverlay').then((closedFeedbackOverlay) => {
      showPopupId.current = setTimeout(() => {
        if (!closedFeedbackOverlay) {
          cache.setItem('closedFeedbackOverlay', false) // default to false
          setShowPopup(true)
        }
      }, waitTime)
    })
    return () => {
      clearTimeout(showPopupId.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClose = () => {
    cache.setItem('closedFeedbackOverlay', true)
    setShowPopup(false)
    handleOnClose()
  }

  return (
    <>
      {showPopup && (
        <div css={containerStyles} data-testid="usabilla-popup">
          <Row>
            <H4>{t('feedbackOverlay.header', 'Share Your Feedback!')}</H4>
            <IconButton
              Icon={MenuClose}
              title={t('feedbackOverlay.button', 'Close Feedback Popup')}
              onClick={handleClose}
              data-testid="close-feedback-overlay"
              linkName="close-feedback-overlay"
            />
          </Row>
          <Separator size="nano" />
          <Row>
            <Paragraph size="sm">{t('feedbackOverlay.content', 'Let us know what you think of this page.')}</Paragraph>
          </Row>
          <Separator size="nano" />
        </div>
      )}
    </>
  )
}
export default FeedbackOverlay
